<template>
  <v-card class="mb-4">
    <v-card-title class="d-flex align-center justify-space-between" style="height: 48px;">
      {{ label }}
      <v-switch
        v-if="initialCountWasPositive"
        class="ma-0 pa-0 custom-switch"
        v-model="localSelected"
        @update:model-value="handleSwitchChange"
        hide-details
        density="compact"
        color="secondary"
      ></v-switch>
    </v-card-title>
    <v-card-text class="text-h3">
      {{ displayCount }}
    </v-card-text>
  </v-card>
</template>

<script src="./model.js"></script>
<style src="./style.css" scoped></style>
